import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-email-flagfilter',
  templateUrl: './email-flagfilter.component.html',
  styleUrls: ['./email-flagfilter.component.sass']
})
export class EmailFlagfilterComponent implements OnInit {

  @Input('flag') flag:number = 0;
  @Output() flagFilterClicked: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {

  }

  onFilterButtonClicked(){
    this.flagFilterClicked.emit();
  }

}
